import FontFaceObserver from 'fontfaceobserver';

export default function loadFonts () {
  const loraObserver = new FontFaceObserver('Lora', {});
  const graphikObserver = new FontFaceObserver('Graphik Web', {});
  if (window.sessionStorage.loraFontLoaded) {
    document.body.classList.add('loraFontLoaded');
  } else {
    loraObserver.load().then(
      () => {
        window.sessionStorage.loraFontLoaded = true;
        document.body.classList.add('loraFontLoaded');
      },
      () => {
        window.sessionStorage.loraFontLoaded = false;
        document.body.classList.remove('loraFontLoaded');
      }
    );
  }

  if (window.sessionStorage.graphikFontLoaded) {
    document.body.classList.add('graphikFontLoaded');
  } else {
    graphikObserver.load().then(
      () => {
        window.sessionStorage.graphikFontLoaded = true;
        document.body.classList.add('graphikFontLoaded');
      },
      () => {
        window.sessionStorage.graphikFontLoaded = false;
        document.body.classList.remove('graphikFontLoaded');
      }
    );
  }
}
